import {map, filter} from 'rxjs/operators';
import {Component, OnInit, ViewChild} from '@angular/core';
import {ITableHeader} from '../../../../shared/table/TableComponent';
import {BehaviorSubject, Observable} from 'rxjs';
import {PledgeSummaryReport} from '../../../../../services/api.client';
import {User} from '../../../../../services/api.client';
import {PledgeReportForm} from '../../PledgeReportForm';
import {SecurityService} from '../../../../../services/SecurityService';

@Component({
    templateUrl: './AgencySummaryReportComponent.html',
    standalone: false
})
export class AgencySummaryReportComponent implements OnInit {
  tableHeaders: ITableHeader[] = [];
  rows: any;

  @ViewChild('form')
  form: PledgeReportForm;

  // subscription
  currentUser: User;
  currentUser$: Observable<User>;
  private readonly _report$ = new BehaviorSubject<PledgeSummaryReport[]>(null);
  report$: Observable<PledgeSummaryReport[]> = this._report$.asObservable();

  constructor(private _securityService: SecurityService) {
      this.currentUser$ = this._securityService.currentUser$;
  }

  submitReport(): void {
      this.form.submitAgencyPledgeSummaryReport()?.subscribe({next: (report) => this._report$.next(report), error: () => {}});
  }

  ngOnInit(): void {
    this.currentUser$.subscribe(user => this.currentUser = user);
    if (this.currentUser.hasPrivate) {
      this.tableHeaders = [
        {text: 'Agency', },
        {text: 'Pledge Type', },
        {text: '# People Helped', },
        {text: '# Pledges', },
        {text: 'Amount', },
        {text: 'Ledger #', },
        {text: 'Private', },
      ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.map(r => [
          r.agencyName,
          r.pledgeType,
          r.helpedCount,
          r.pledgeCount,
          '$ ' + r.pledgeAmount.toFixed(2),
          r.ledgerNumber,
          r.isPrivate
        ])), );

    } else {
      this.tableHeaders = [
        {text: 'Agency', },
        {text: 'Pledge Type', },
        {text: '# People Helped', },
        {text: '# Pledges', },
        {text: 'Amount', },
        {text: 'Ledger #', },
      ];

      this.rows = this.report$.pipe(
        filter(report => !!report),
        map((report) => report.map(r => [
          r.agencyName,
          r.pledgeType,
          r.helpedCount,
          r.pledgeCount,
          '$ ' + r.pledgeAmount.toFixed(2),
          r.ledgerNumber
        ])), );
    }
  }
}
